export const CHILD_FEATURES = {
  ORDERS: "ORDERS",
  PRODUCTS: "PRODUCTS",
  RECONCILE_NORMAL: "RECONCILE_NORMAL",
  RECONCILE_VAT: "RECONCILE_VAT",
  TTH_VIEW: "TTH_VIEW",
};

// Phân quyền cấp CỘT (trong 1 màn hình đã được cấp quyền truy cập ở trên qua CHILD_FEATURES).
// Khớp 1-1 với ChildUserFeature.java (backend) - backend đã null hóa field tương ứng khi cột bị
// ẩn, nên các cờ này chỉ cần dùng để không render <th>/<td> cho gọn giao diện.
export const ORDER_COLUMNS = {
  LINE: "ORDERS_COL_LINE",
  CN_CODE: "ORDERS_COL_CN_CODE",
  VN_CODE: "ORDERS_COL_VN_CODE",
  PRODUCT_NAME: "ORDERS_COL_PRODUCT_NAME",
  PACKAGE: "ORDERS_COL_PACKAGE",
  WEIGHT_VOLUME: "ORDERS_COL_WEIGHT_VOLUME",
  INSURANCE: "ORDERS_COL_INSURANCE",
  SHIPPING_METHOD: "ORDERS_COL_SHIPPING_METHOD",
  NOTE: "ORDERS_COL_NOTE",
  PROGRESS: "ORDERS_COL_PROGRESS",
  RECONCILE: "ORDERS_COL_RECONCILE",
};

export const RECONCILE_NORMAL_COLUMNS = {
  NAME: "RECONCILE_NORMAL_COL_NAME",
  ORDER_COUNT: "RECONCILE_NORMAL_COL_ORDER_COUNT",
  FEE: "RECONCILE_NORMAL_COL_FEE",
  STATUS: "RECONCILE_NORMAL_COL_STATUS",
};

export const RECONCILE_VAT_COLUMNS = {
  NAME: "RECONCILE_VAT_COL_NAME",
  QUANTITY: "RECONCILE_VAT_COL_QUANTITY",
  MONEY: "RECONCILE_VAT_COL_MONEY",
  STATUS: "RECONCILE_VAT_COL_STATUS",
};

export const TTH_COLUMNS = {
  QUANTITY: "TTH_COL_QUANTITY",
  RATE: "TTH_COL_RATE",
  AMOUNT: "TTH_COL_AMOUNT",
  STATUS: "TTH_COL_STATUS",
  NOTE: "TTH_COL_NOTE",
};

export const canViewChildFeature = (config, feature) => {
  if (!config?.isChildAccount) {
    return true;
  }
  return config?.childFeatureViews?.[feature] === true;
};
